module.exports = __webpack_public_path__ + "static/img/productsTwo.b90a59d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/productsTwo.jpg
// module id = NYAk
// module chunks = 1